<template>
  <div class="mx-auto max-w-3xl px-6">
    <slot />
  </div>
</template>
